require('jquery-ui/ui/widget');
require('jquery-ui/ui/position');
require('jquery-ui/ui/keycode');
require('jquery-ui/ui/unique-id');
require('jquery-ui/ui/widgets/tooltip');
require('jquery-ui/themes/base/core.css');
require('jquery-ui/themes/base/tooltip.css');